import { defineDataset } from './metadata';
import epochChipSalesH100e from './epochChipSalesH100e';
import epochDataCenterProjects from './epochDataCenterProjects';

const semiAnalysisGpuRentalIndex = {
    A100: [
        ['2023-06-30', 1.64], ['2023-07-31', 1.64], ['2023-08-31', 1.64], ['2023-09-30', 1.67],
        ['2023-10-31', 1.43], ['2023-11-30', 1.53], ['2023-12-31', 1.40], ['2024-01-31', 1.35],
        ['2024-02-29', 1.37], ['2024-03-31', 1.42], ['2024-04-30', 1.44], ['2024-05-31', 1.44],
        ['2024-06-30', 1.52], ['2024-07-31', 1.53], ['2024-08-31', 1.56], ['2024-09-30', 1.52],
        ['2024-10-31', 1.50], ['2024-11-30', 1.53], ['2024-12-31', 1.54], ['2025-01-31', 1.56],
        ['2025-02-28', 1.56], ['2025-03-31', 1.55], ['2025-04-30', 1.35], ['2025-05-31', 1.49],
        ['2025-06-30', 1.27], ['2025-07-31', 1.38], ['2025-08-31', 1.42], ['2025-09-30', 1.37],
        ['2025-10-31', 1.40], ['2025-11-30', 1.31], ['2025-12-31', 1.32], ['2026-01-31', 1.32],
        ['2026-02-28', 1.43], ['2026-03-31', 1.52], ['2026-04-30', 1.50], ['2026-05-31', 1.63],
        ['2026-06-30', 1.54], ['2026-07-31', 1.78], ['2026-08-09', 1.81],
    ],
    H100: [
        ['2023-10-31', 6.52], ['2023-11-30', 6.38], ['2023-12-31', 5.80], ['2024-01-31', 5.76],
        ['2024-02-29', 5.65], ['2024-03-31', 5.14], ['2024-04-30', 5.03], ['2024-05-31', 4.73],
        ['2024-06-30', 4.36], ['2024-07-31', 4.47], ['2024-08-31', 4.48], ['2024-09-30', 4.32],
        ['2024-10-31', 4.02], ['2024-11-30', 3.92], ['2024-12-31', 3.96], ['2025-01-31', 3.19],
        ['2025-02-28', 3.50], ['2025-03-31', 3.38], ['2025-04-30', 3.62], ['2025-05-31', 3.66],
        ['2025-06-30', 2.76], ['2025-07-31', 2.84], ['2025-08-31', 2.95], ['2025-09-30', 2.84],
        ['2025-10-31', 2.84], ['2025-11-30', 2.79], ['2025-12-31', 2.82], ['2026-01-31', 2.75],
        ['2026-02-28', 2.80], ['2026-03-31', 2.83], ['2026-04-30', 2.98], ['2026-05-31', 2.95],
        ['2026-06-30', 3.07], ['2026-07-31', 3.18], ['2026-08-09', 3.19],
    ],
    B200: [
        ['2025-06-30', 5.25], ['2025-07-31', 3.83], ['2025-08-31', 4.39], ['2025-09-30', 4.49],
        ['2025-10-31', 4.07], ['2025-11-30', 4.46], ['2025-12-31', 4.57], ['2026-01-31', 3.90],
        ['2026-02-28', 4.00], ['2026-03-31', 4.11], ['2026-04-30', 4.74], ['2026-05-31', 4.83],
        ['2026-06-30', 4.59], ['2026-07-31', 5.42], ['2026-08-09', 5.43],
    ],
};

const semiAnalysisGpuRentalSeries = Object.entries(semiAnalysisGpuRentalIndex)
    .flatMap(([accelerator, observations]) => observations.map(([date, value]) => ({
        date,
        value,
        accelerator,
        evidenceType: 'published_composite_index',
    })))
    .sort((a, b) => a.date.localeCompare(b.date) || a.accelerator.localeCompare(b.accelerator));

const trendForceDdr5SpotSeries = [
    ['2022-12-31', 5.249], ['2023-01-31', 4.726], ['2023-02-28', 4.190], ['2023-03-31', 3.929],
    ['2023-04-30', 4.157], ['2023-05-31', 4.155], ['2023-06-30', 4.064], ['2023-07-31', 3.970],
    ['2023-08-31', 4.050], ['2023-09-30', 4.148], ['2023-10-31', 4.154], ['2023-11-30', 4.231],
    ['2023-12-31', 4.383], ['2024-01-31', 4.674], ['2024-02-29', 4.702], ['2024-03-31', 4.780],
    ['2024-04-30', 4.889], ['2024-05-31', 4.845], ['2024-06-30', 5.000], ['2024-07-31', 5.144],
    ['2024-08-31', 4.997], ['2024-09-30', 4.872], ['2024-10-31', 4.788], ['2024-11-30', 4.720],
    ['2024-12-31', 4.679], ['2025-01-31', 4.773], ['2025-02-28', 5.104], ['2025-03-31', 5.403],
    ['2025-04-30', 5.515], ['2025-05-31', 5.850], ['2025-06-30', 6.107], ['2025-07-31', 6.120],
    ['2025-08-31', 6.569], ['2025-09-30', 10.664], ['2025-10-31', 23.216], ['2025-11-30', 26.951],
    ['2025-12-31', 34.336], ['2026-01-31', 38.253], ['2026-02-28', 38.976], ['2026-03-31', 37.874],
    ['2026-04-30', 40.657], ['2026-05-31', 44.946], ['2026-06-30', 49.030],
].map(([date, value]) => ({
    date,
    value,
    product: 'DDR5 16Gb (2Gx8) 4800/5600',
    evidenceType: 'monthly_average',
}));

trendForceDdr5SpotSeries.push({
    date: '2026-08-07',
    value: 51.60,
    product: 'DDR5 16Gb (2Gx8) 4800/5600',
    evidenceType: 'latest_session_average',
});

const epochOperationalCapacitySeries = [
    { date: '2022-12-31', value: 0.048, h100EquivalentMillions: 0.008, trackedSites: 17, activeSites: 1, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
    { date: '2023-12-31', value: 0.295, h100EquivalentMillions: 0.131, trackedSites: 33, activeSites: 4, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
    { date: '2024-12-31', value: 1.484, h100EquivalentMillions: 0.873, trackedSites: 59, activeSites: 17, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
    { date: '2025-03-31', value: 2.021, h100EquivalentMillions: 1.2, trackedSites: 62, activeSites: 19, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
    { date: '2025-06-30', value: 3.078, h100EquivalentMillions: 2.182, trackedSites: 65, activeSites: 24, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
    { date: '2025-09-30', value: 3.719, h100EquivalentMillions: 3.086, trackedSites: 67, activeSites: 30, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
    { date: '2025-12-31', value: 5.655, h100EquivalentMillions: 5.184, trackedSites: 71, activeSites: 36, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
    { date: '2026-03-31', value: 6.965, h100EquivalentMillions: 6.532, trackedSites: 73, activeSites: 41, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
    { date: '2026-06-30', value: 10.575, h100EquivalentMillions: 11.097, trackedSites: 73, activeSites: 54, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
    { date: '2026-07-16', value: 11.299, h100EquivalentMillions: 11.928, trackedSites: 73, activeSites: 55, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
    { date: '2026-08-09', value: 12.098, h100EquivalentMillions: 12.909, trackedSites: 77, activeSites: 63, status: 'tracked_operational_capacity', evidenceType: 'derived_from_dated_site_snapshots', capacityType: 'operational' },
];

const latestOperationalCapacity = epochOperationalCapacitySeries[epochOperationalCapacitySeries.length - 1];
const epochFutureMilestoneDates = [...new Set(epochDataCenterProjects.projects
    .flatMap((project) => project.timeline.map((point) => point.date))
    .filter((date) => date > epochDataCenterProjects.asOf))]
    .sort();

const projectedSiteStateAt = (project, date) => {
    const latestEstimate = [...project.timeline]
        .filter((point) => point.date <= date && Number.isFinite(point.itPowerMw))
        .sort((a, b) => a.date.localeCompare(b.date))
        .at(-1);
    const currentPowerMw = Number.isFinite(project.currentPowerMw) ? project.currentPowerMw : 0;
    const currentH100Equivalent = Number.isFinite(project.currentH100Equivalent) ? project.currentH100Equivalent : 0;
    return {
        powerMw: Math.max(currentPowerMw, latestEstimate?.itPowerMw || 0),
        h100Equivalent: Math.max(currentH100Equivalent, latestEstimate?.h100Equivalent || 0),
    };
};

const epochPlannedCapacitySeries = [
    {
        ...latestOperationalCapacity,
        status: 'planned_capacity_estimate',
        evidenceType: 'derived_from_future_site_milestones',
        capacityType: 'planned_estimate',
    },
    ...epochFutureMilestoneDates.map((date) => {
        const siteStates = epochDataCenterProjects.projects.map((project) => projectedSiteStateAt(project, date));
        return {
            date,
            value: siteStates.reduce((sum, site) => sum + site.powerMw, 0) / 1000,
            h100EquivalentMillions: siteStates.reduce((sum, site) => sum + site.h100Equivalent, 0) / 1e6,
            trackedSites: epochDataCenterProjects.projects.length,
            activeSites: siteStates.filter((site) => site.powerMw > 0).length,
            status: 'planned_capacity_estimate',
            evidenceType: 'derived_from_future_site_milestones',
            capacityType: 'planned_estimate',
        };
    }),
];

const epochCapacitySeries = [...epochOperationalCapacitySeries, ...epochPlannedCapacitySeries]
    .sort((a, b) => a.date.localeCompare(b.date) || a.capacityType.localeCompare(b.capacityType));

const epochChipSalesH100eSeries = [...epochChipSalesH100e.records.reduce((periods, row) => {
    const current = periods.get(row.periodEnd) || {
        date: row.periodEnd,
        value: 0,
        low: 0,
        high: 0,
        incomplete: false,
        evidenceType: 'epoch_median_estimate',
    };
    current.value += row.median;
    current.low += row.low;
    current.high += row.high;
    current.incomplete = current.incomplete || row.incomplete;
    periods.set(row.periodEnd, current);
    return periods;
}, new Map()).values()].sort((a, b) => a.date.localeCompare(b.date));

export const computeMarketDatasets = [
    defineDataset({
        datasetId: 'epoch_data_center_capacity',
        moduleId: 'compute_market',
        title: 'Tracked operational and planned AI data-center IT capacity',
        titleZh: '已追踪 AI 数据中心投运与规划 IT 容量',
        sourceName: 'Epoch AI Data Centers Hub',
        sourceUrl: 'https://epoch.ai/data/ai-data-centers?view=graph',
        downloadUrl: 'https://epoch.ai/data/data-centers/data_centers.zip',
        license: 'CC-BY',
        asOf: '2026-08-09',
        retrievedAt: '2026-08-09',
        coverageStart: '2022-12-31',
        coverageEnd: epochFutureMilestoneDates.at(-1) || '2026-08-09',
        grain: 'quarter-end/latest operational snapshot and future site milestone',
        unit: 'GW IT power',
        methodologyNote: 'For historical points, take the latest dated timeline record available for every tracked site and sum operational IT power. The projected line starts at the retrieval-date total, then carries each site forward to Epoch’s dated future buildout milestones without counting any estimate as already operational.',
        coverageNote: 'Operational and planned lines are a tracked-sample view, not global installed capacity. Epoch estimates its database covered about 27% of globally delivered AI compute as of April 2026 and prioritizes large, newer AI sites. Future IT power and dates are estimates and may change.',
        confidence: 'medium',
        series: epochCapacitySeries,
    }),
    defineDataset({
        datasetId: 'epoch_data_center_owner_capacity',
        moduleId: 'compute_market',
        title: 'Current tracked IT capacity by owner',
        titleZh: '当前已追踪 IT 容量（按所有者）',
        sourceName: 'Epoch AI Data Centers Hub',
        sourceUrl: 'https://epoch.ai/data/ai-data-centers',
        downloadUrl: 'https://epoch.ai/data/data-centers/data_centers.zip',
        license: 'CC-BY',
        asOf: '2026-08-09',
        retrievedAt: '2026-08-09',
        coverageStart: '2026-08-09',
        coverageEnd: '2026-08-09',
        grain: 'owner aggregate snapshot',
        unit: 'GW IT power',
        methodologyNote: 'Normalize the owner label before its confidence tag and sum each site’s current IT power by owner. Small owners are grouped into Other; unidentified owners remain Unknown.',
        coverageNote: 'Ownership is not the same as model-company usage. Some ownership and user relationships are uncertain or shared.',
        confidence: 'medium',
        status: 'partial',
        series: [
            { date: '2026-08-09', value: 2.818, owner: 'Google', h100EquivalentMillions: 3.481, sites: 20 },
            { date: '2026-08-09', value: 2.125, owner: 'Meta', h100EquivalentMillions: 2.48, sites: 13 },
            { date: '2026-08-09', value: 1.519, owner: 'Microsoft', h100EquivalentMillions: 1.685, sites: 7 },
            { date: '2026-08-09', value: 1.422, owner: 'Amazon', h100EquivalentMillions: 1.072, sites: 3 },
            { date: '2026-08-09', value: 1.303, owner: 'SpaceXAI', h100EquivalentMillions: 1.399, sites: 3 },
            { date: '2026-08-09', value: 0.983, owner: 'Unknown', h100EquivalentMillions: 1.028, sites: 8 },
            { date: '2026-08-09', value: 0.637, owner: 'CoreWeave', h100EquivalentMillions: 0.705, sites: 7 },
            { date: '2026-08-09', value: 0.493, owner: 'Oracle', h100EquivalentMillions: 0.594, sites: 6 },
            { date: '2026-08-09', value: 0.798, owner: 'Other', h100EquivalentMillions: 0.833, sites: 11 },
        ],
    }),
    defineDataset({
        datasetId: 'epoch_data_center_projects',
        moduleId: 'compute_market',
        title: 'AI data-center project buildout timelines',
        titleZh: 'AI 数据中心项目建设时间线',
        sourceName: 'Epoch AI Data Centers Directory',
        sourceUrl: 'https://epoch.ai/data/ai-data-centers/directory',
        downloadUrl: 'https://epoch.ai/data/data-centers/data_centers.zip',
        license: 'CC-BY',
        asOf: epochDataCenterProjects.asOf,
        retrievedAt: '2026-08-09',
        coverageStart: '2018-12-18',
        coverageEnd: '2030-01-01',
        grain: 'data-center project and dated buildout observation',
        unit: 'MW IT power and H100-equivalent compute',
        methodologyNote: 'Retain all 77 project records and their dated construction timelines. Current observations are separated from future Epoch estimates by comparing each timeline date with the snapshot date; free-text construction notes remain unclassified.',
        coverageNote: 'Epoch prioritizes large, newer AI data centers and estimates that the database covered about 27% of globally delivered AI compute as of April 2026. IT power, compute, cost and dates are estimates; Epoch expects 80% of timeline dates to be within six months of the actual date.',
        confidence: 'medium',
        status: 'partial',
        projects: epochDataCenterProjects.projects,
        series: epochDataCenterProjects.projects.map((project) => ({
            date: epochDataCenterProjects.asOf,
            value: project.currentPowerMw,
            project: project.name,
            owner: project.owner,
            h100Equivalent: project.currentH100Equivalent,
        })),
    }),
    defineDataset({
        datasetId: 'epoch_chip_sales_h100e',
        moduleId: 'compute_market',
        title: 'Quarterly AI chip compute delivered in H100 equivalents',
        titleZh: 'AI 芯片季度交付算力（H100 等效）',
        sourceName: 'Epoch AI Chip Sales',
        sourceUrl: 'https://epoch.ai/data/ai-chip-sales?view=graph&tab=h100_equivalents',
        downloadUrl: 'https://epoch.ai/data/ai_chip_sales_timelines_by_chip.csv',
        license: 'CC-BY',
        asOf: epochChipSalesH100e.asOf,
        retrievedAt: '2026-08-09',
        coverageStart: epochChipSalesH100eSeries[0].date,
        coverageEnd: epochChipSalesH100eSeries[epochChipSalesH100eSeries.length - 1].date,
        grain: 'calendar quarter and chip type',
        unit: 'H100-equivalent accelerators',
        methodologyNote: 'Sum Epoch’s median H100-equivalent compute estimates across chip types for each quarter and designer. H100e normalizes each chip by peak dense 8-bit operations relative to one Nvidia H100. The cumulative view sums quarterly deliveries without subtracting retirements.',
        coverageNote: 'These are delivered or ready-for-installation chip estimates, not necessarily operational data-center capacity or realized workload performance. Aggregate low/high totals sum row-level 5th and 95th percentiles for orientation; uncertainty is not guaranteed to be independent. The latest quarter is incomplete.',
        confidence: 'medium',
        status: 'partial',
        records: epochChipSalesH100e.records,
        series: epochChipSalesH100eSeries,
    }),
    defineDataset({
        datasetId: 'epoch_accelerator_shipments',
        moduleId: 'compute_market',
        title: 'Estimated Nvidia AI accelerator shipments',
        titleZh: '英伟达 AI 加速卡出货估算',
        sourceName: 'Epoch AI Chip Sales',
        sourceUrl: 'https://epoch.ai/data/ai-chip-sales',
        downloadUrl: 'https://epoch.ai/data/ai_chip_sales.zip',
        license: 'CC-BY',
        asOf: '2026-06-30',
        retrievedAt: '2026-07-16',
        coverageStart: '2022-01-01',
        coverageEnd: '2026-06-30',
        grain: 'quarter and chip family estimate',
        unit: 'accelerator units',
        methodologyNote: 'Retain quarterly Nvidia A100, H100/H200, H20, B200, and B300 median unit estimates with 5th and 95th percentiles. The last quarter remains flagged incomplete.',
        coverageNote: 'Epoch estimates shipments from company disclosures, supply-chain evidence, and semiconductor capacity. B300 replaces B200 as the dominant tracked Nvidia family in 2025; Rubin has no shipped-quarter observation in this extract.',
        confidence: 'medium',
        series: [
            { date: '2022-01-01', value: 147645, chip: 'A100', low: 113423, high: 191482, incomplete: true },
            { date: '2022-04-01', value: 226324, chip: 'A100', low: 173378, high: 293623, incomplete: false },
            { date: '2022-07-01', value: 215200, chip: 'A100', low: 165507, high: 279450, incomplete: false },
            { date: '2022-07-01', value: 6106, chip: 'H100/H200', low: 5148, high: 7204, incomplete: false },
            { date: '2022-10-01', value: 113277, chip: 'A100', low: 87190, high: 147290, incomplete: false },
            { date: '2022-10-01', value: 32492, chip: 'H100/H200', low: 27372, high: 38332, incomplete: false },
            { date: '2023-01-01', value: 58773, chip: 'A100', low: 45347, high: 76478, incomplete: false },
            { date: '2023-01-01', value: 56536, chip: 'H100/H200', low: 47792, high: 66904, incomplete: false },
            { date: '2023-04-01', value: 64286, chip: 'A100', low: 49564, high: 83810, incomplete: false },
            { date: '2023-04-01', value: 150868, chip: 'H100/H200', low: 127870, high: 179142, incomplete: false },
            { date: '2023-07-01', value: 54904, chip: 'A100', low: 42108, high: 71649, incomplete: false },
            { date: '2023-07-01', value: 259631, chip: 'H100/H200', low: 219080, high: 307406, incomplete: false },
            { date: '2023-10-01', value: 15130, chip: 'A100', low: 11574, high: 19746, incomplete: false },
            { date: '2023-10-01', value: 422172, chip: 'H100/H200', low: 355867, high: 500558, incomplete: false },
            { date: '2024-01-01', value: 550503, chip: 'H100/H200', low: 466753, high: 647115, incomplete: false },
            { date: '2024-01-01', value: 139117, chip: 'H20', low: 107118, high: 181766, incomplete: false },
            { date: '2024-04-01', value: 648803, chip: 'H100/H200', low: 552079, high: 761640, incomplete: false },
            { date: '2024-04-01', value: 223789, chip: 'H20', low: 172854, high: 290498, incomplete: false },
            { date: '2024-07-01', value: 791332, chip: 'H100/H200', low: 675899, high: 930021, incomplete: false },
            { date: '2024-07-01', value: 274454, chip: 'H20', low: 212258, high: 354333, incomplete: false },
            { date: '2024-10-01', value: 201198, chip: 'B200', low: 171886, high: 234850, incomplete: false },
            { date: '2024-10-01', value: 681252, chip: 'H100/H200', low: 580308, high: 796953, incomplete: false },
            { date: '2024-10-01', value: 325386, chip: 'H20', low: 251072, high: 424357, incomplete: false },
            { date: '2025-01-01', value: 520940, chip: 'B200', low: 444056, high: 608605, incomplete: false },
            { date: '2025-01-01', value: 328883, chip: 'H100/H200', low: 274294, high: 392144, incomplete: false },
            { date: '2025-01-01', value: 362365, chip: 'H20', low: 298201, high: 439700, incomplete: false },
            { date: '2025-04-01', value: 436018, chip: 'B200', low: 373418, high: 508893, incomplete: false },
            { date: '2025-04-01', value: 215467, chip: 'B300', low: 182592, high: 253869, incomplete: false },
            { date: '2025-04-01', value: 227846, chip: 'H100/H200', low: 186151, high: 278409, incomplete: false },
            { date: '2025-04-01', value: 153073, chip: 'H20', low: 128948, high: 180663, incomplete: false },
            { date: '2025-07-01', value: 347023, chip: 'B200', low: 297528, high: 404125, incomplete: false },
            { date: '2025-07-01', value: 541067, chip: 'B300', low: 460762, high: 637915, incomplete: false },
            { date: '2025-07-01', value: 126826, chip: 'H100/H200', low: 103574, high: 155230, incomplete: false },
            { date: '2025-07-01', value: 17168, chip: 'H20', low: 14497, high: 20328, incomplete: false },
            { date: '2025-10-01', value: 416504, chip: 'B200', low: 357988, high: 490079, incomplete: false },
            { date: '2025-10-01', value: 744907, chip: 'B300', low: 632276, high: 873201, incomplete: false },
            { date: '2025-10-01', value: 23295, chip: 'H100/H200', low: 19005, high: 28561, incomplete: false },
            { date: '2026-01-01', value: 347290, chip: 'B200', low: 296207, high: 406782, incomplete: false },
            { date: '2026-01-01', value: 992874, chip: 'B300', low: 841132, high: 1166624, incomplete: false },
            { date: '2026-04-01', value: 90245, chip: 'B200', low: 76971, high: 105704, incomplete: true },
            { date: '2026-04-01', value: 311796, chip: 'B300', low: 264144, high: 366360, incomplete: true },
        ],
    }),
    defineDataset({
        datasetId: 'dram_spot_price',
        moduleId: 'compute_market',
        title: 'Mainstream DDR5 DRAM spot-price history',
        titleZh: '主流 DDR5 DRAM 现货价格历史',
        sourceName: 'TrendForce DataTrack and DRAM price page',
        sourceUrl: 'https://datatrack.trendforce.com/Chart/content/4694/mainstream-dram-spot-price',
        downloadUrl: 'https://www.trendforce.com/price/dram/dram_spot',
        license: 'Provider terms',
        asOf: '2026-08-07',
        retrievedAt: '2026-08-09',
        coverageStart: '2022-12-31',
        coverageEnd: '2026-08-07',
        grain: 'month-end average plus latest published session average',
        unit: 'USD per chip',
        methodologyNote: 'Plot TrendForce DataTrack monthly observations for the DDR5 16Gb (2Gx8) 4800/5600 mainstream spot price. Append the latest public-session average from TrendForce’s DRAM price page. July 2026 is not interpolated because the public DataTrack series currently ends in June.',
        coverageNote: 'This is a channel spot quote for one DRAM chip specification, not a memory-module price. DRAM has no standardized exchange-traded futures series; TrendForce publishes spot and OEM contract prices. Its public contract snapshot uses different products, so it is shown separately rather than overlaid as a comparable line. Full multi-year contract-price history requires DRAMeXchange membership.',
        confidence: 'high',
        status: 'partial',
        product: 'DDR5 16Gb (2Gx8) 4800/5600',
        latestSpotPrice: 51.60,
        latestSpotDate: '2026-08-07',
        contractPriceDate: '2026-06-30',
        contractQuotes: [
            { product: 'DDR5 8GB SO-DIMM', value: 115, unit: 'USD per module' },
            { product: 'DDR4 16GB SO-DIMM', value: 227, unit: 'USD per module' },
            { product: 'DDR4 16Gb (2Gx8)', value: 42, unit: 'USD per chip' },
        ],
        series: trendForceDdr5SpotSeries,
    }),
    defineDataset({
        datasetId: 'enterprise_ssd_vendor_revenue_1q26',
        moduleId: 'compute_market',
        title: 'Enterprise SSD revenue by leading vendor in 1Q26',
        titleZh: '2026 年一季度企业级 SSD 头部厂商收入',
        sourceName: 'TrendForce Enterprise SSD analysis',
        sourceUrl: 'https://www.trendforce.com/presscenter/news/20260611-13092.html',
        license: 'Provider terms',
        asOf: '2026-06-11',
        retrievedAt: '2026-08-09',
        coverageStart: '2026-01-01',
        coverageEnd: '2026-03-31',
        grain: 'quarter and vendor',
        unit: 'USD billions per quarter',
        methodologyNote: 'Retain TrendForce’s reported 1Q26 enterprise-SSD revenue for the five leading suppliers. Displayed market shares normalize the rounded vendor values to their sum; the headline industry total remains TrendForce’s reported US$18.46 billion.',
        coverageNote: 'This is enterprise SSD revenue, not NAND-wide revenue, shipped exabytes, installed storage capacity, or end-customer spending. Vendor figures are rounded and sum to US$18.47 billion, US$0.01 billion above the reported industry headline.',
        confidence: 'medium',
        status: 'partial',
        reportedTotal: 18.46,
        quarterGrowth: 86.1,
        contractPriceGrowth: 80,
        series: [
            { date: '2026-03-31', value: 7.05, vendor: 'Samsung', color: '#153f78', evidenceType: 'reported' },
            { date: '2026-03-31', value: 4.64, vendor: 'SK hynix Group', color: '#11998e', evidenceType: 'reported' },
            { date: '2026-03-31', value: 3.09, vendor: 'Micron', color: '#d4853f', evidenceType: 'reported' },
            { date: '2026-03-31', value: 2.22, vendor: 'Kioxia', color: '#6d5eb5', evidenceType: 'reported' },
            { date: '2026-03-31', value: 1.47, vendor: 'SanDisk', color: '#a47a34', evidenceType: 'reported' },
        ],
    }),
    defineDataset({
        datasetId: 'gpu_rental_prices',
        moduleId: 'compute_market',
        title: 'GPU rental price index history',
        titleZh: 'GPU 租赁价格指数历史',
        sourceName: 'SemiAnalysis GPU Spot-Contract Composite Index',
        sourceUrl: 'https://gpu-index.semianalysis.com/',
        downloadUrl: 'https://gpu-index.semianalysis.com/api/public-data',
        license: 'Provider terms',
        asOf: '2026-08-09',
        retrievedAt: '2026-08-09',
        coverageStart: '2023-06-30',
        coverageEnd: '2026-08-09',
        grain: 'month-end composite index by GPU family; latest day for the partial month',
        unit: 'USD per GPU-hour',
        methodologyNote: 'Sample the final published daily observation in each calendar month from the SemiAnalysis public API. The source index combines GPU rental prices across hyperscalers, neoclouds, marketplaces, aggregators and contract-pricing surveys into a composition-jump-resistant weighted mean.',
        coverageNote: 'This is a market index, not a directly executable provider quote. It mixes spot and contract observations under the source methodology; networking, CPU/RAM bundles, regions, availability, taxes, commitments and negotiated terms still differ.',
        confidence: 'medium',
        series: semiAnalysisGpuRentalSeries,
    }),
    defineDataset({
        datasetId: 'hyperscaler_capex',
        moduleId: 'compute_market',
        title: 'Quarterly hyperscaler cash capital expenditure and outlook',
        titleZh: '主要云厂商季度现金资本开支与预测',
        sourceName: 'SEC filings and company earnings guidance',
        sourceUrl: 'https://data.sec.gov/api/xbrl/companyfacts/',
        license: 'Public filings',
        asOf: '2026-08-09',
        retrievedAt: '2026-08-09',
        coverageStart: '2024-06-30',
        coverageEnd: '2027-06-30',
        grain: 'fiscal quarter by company; four-quarter base-case forecast',
        unit: 'USD billions per quarter',
        methodologyNote: 'Actuals use SEC XBRL cash purchases of property and equipment (Amazon uses payments to acquire productive assets); standalone Q4 values are annual less year-to-date Q3. Annual view uses complete company fiscal-year totals rather than annualizing partial quarters. Forecasts are InvestFlow base-case estimates anchored to the midpoint of official 2026 capital-investment plans and recent quarterly pacing. Microsoft guidance includes finance leases; Meta guidance includes finance-lease principal; Oracle has no explicit FY2027 CapEx guide, so its estimate uses the latest run rate and disclosed capital-funding plan.',
        coverageNote: 'Total company CapEx is not AI-only spend. Cash definitions, fiscal calendars, finance leases, supplier financing, incentives, and customer prepayments differ, so compare direction and scale rather than treating every dollar as perfectly like-for-like. Forecast points are estimates, not reported results or analyst consensus.',
        confidence: 'medium',
        status: 'partial',
        companies: [
            { id: 'Microsoft', label: 'Microsoft', color: '#153f78', definition: 'Cash paid for property and equipment', definitionZh: '现金购置物业及设备', sourceUrl: 'https://www.microsoft.com/en-us/Investor/events/fy-2026/earnings-fy-2026-q3' },
            { id: 'Amazon', label: 'Amazon', color: '#d4853f', definition: 'Payments to acquire productive assets', definitionZh: '购置生产性资产的现金支出', sourceUrl: 'https://ir.aboutamazon.com/news-release/news-release-details/2026/Amazon-com-Announces-Fourth-Quarter-Results/default.aspx' },
            { id: 'Alphabet', label: 'Alphabet', color: '#11998e', definition: 'Purchases of property and equipment', definitionZh: '购置物业及设备', sourceUrl: 'https://abc.xyz/investor/events/event-details/2026/2025-Q4-Earnings-Call-2026-Dr_C033hS6/default.aspx' },
            { id: 'Meta', label: 'Meta', color: '#6d5eb5', definition: 'Purchases of property and equipment', definitionZh: '购置物业及设备', sourceUrl: 'https://investor.atmeta.com/investor-news/press-release-details/2026/Meta-Reports-First-Quarter-2026-Results/' },
            { id: 'Oracle', label: 'Oracle', color: '#b05f48', definition: 'Purchases of property, plant and equipment', definitionZh: '购置物业、厂房及设备', sourceUrl: 'https://investor.oracle.com/investor-news/news-details/2026/Oracle-Announces-Record-Q4-and-FY-2026-Results-Driven-by-Cloud-Infrastructure--Cloud-Applications/' },
        ],
        annualSeries: [
            { company: 'Microsoft', period: 'previous', label: 'FY2025', value: 64.551, evidenceType: 'actual' },
            { company: 'Microsoft', period: 'latest', label: 'FY2026', value: 115.948, evidenceType: 'actual' },
            { company: 'Microsoft', period: 'forecast', label: 'FY2027E', value: 201.000, evidenceType: 'forecast' },
            { company: 'Amazon', period: 'previous', label: '2024', value: 82.999, evidenceType: 'actual' },
            { company: 'Amazon', period: 'latest', label: '2025', value: 131.819, evidenceType: 'actual' },
            { company: 'Amazon', period: 'forecast', label: '2026E', value: 200.000, evidenceType: 'forecast' },
            { company: 'Alphabet', period: 'previous', label: '2024', value: 52.535, evidenceType: 'actual' },
            { company: 'Alphabet', period: 'latest', label: '2025', value: 91.447, evidenceType: 'actual' },
            { company: 'Alphabet', period: 'forecast', label: '2026E', value: 180.000, evidenceType: 'forecast' },
            { company: 'Meta', period: 'previous', label: '2024', value: 37.256, evidenceType: 'actual' },
            { company: 'Meta', period: 'latest', label: '2025', value: 69.691, evidenceType: 'actual' },
            { company: 'Meta', period: 'forecast', label: '2026E', value: 135.000, evidenceType: 'forecast' },
            { company: 'Oracle', period: 'previous', label: 'FY2025', value: 21.215, evidenceType: 'actual' },
            { company: 'Oracle', period: 'latest', label: 'FY2026', value: 55.663, evidenceType: 'actual' },
            { company: 'Oracle', period: 'forecast', label: 'FY2027E', value: 84.000, evidenceType: 'forecast' },
        ],
        series: [
            { date: '2024-06-30', value: 8.173, company: 'Meta', quarter: '2024 Q2', evidenceType: 'actual' },
            { date: '2024-08-31', value: 2.303, company: 'Oracle', quarter: 'FY2025 Q1', evidenceType: 'actual' },
            { date: '2024-09-30', value: 14.923, company: 'Microsoft', quarter: 'FY2025 Q1', evidenceType: 'actual' },
            { date: '2024-09-30', value: 22.620, company: 'Amazon', quarter: '2024 Q3', evidenceType: 'actual' },
            { date: '2024-09-30', value: 13.061, company: 'Alphabet', quarter: '2024 Q3', evidenceType: 'actual' },
            { date: '2024-09-30', value: 8.258, company: 'Meta', quarter: '2024 Q3', evidenceType: 'actual' },
            { date: '2024-11-30', value: 3.970, company: 'Oracle', quarter: 'FY2025 Q2', evidenceType: 'actual' },
            { date: '2024-12-31', value: 15.804, company: 'Microsoft', quarter: 'FY2025 Q2', evidenceType: 'actual' },
            { date: '2024-12-31', value: 27.834, company: 'Amazon', quarter: '2024 Q4', evidenceType: 'actual' },
            { date: '2024-12-31', value: 14.276, company: 'Alphabet', quarter: '2024 Q4', evidenceType: 'actual' },
            { date: '2024-12-31', value: 14.425, company: 'Meta', quarter: '2024 Q4', evidenceType: 'actual' },
            { date: '2025-02-28', value: 5.862, company: 'Oracle', quarter: 'FY2025 Q3', evidenceType: 'actual' },
            { date: '2025-03-31', value: 16.745, company: 'Microsoft', quarter: 'FY2025 Q3', evidenceType: 'actual' },
            { date: '2025-03-31', value: 25.019, company: 'Amazon', quarter: '2025 Q1', evidenceType: 'actual' },
            { date: '2025-03-31', value: 17.197, company: 'Alphabet', quarter: '2025 Q1', evidenceType: 'actual' },
            { date: '2025-03-31', value: 12.941, company: 'Meta', quarter: '2025 Q1', evidenceType: 'actual' },
            { date: '2025-05-31', value: 9.080, company: 'Oracle', quarter: 'FY2025 Q4', evidenceType: 'actual' },
            { date: '2025-06-30', value: 17.079, company: 'Microsoft', quarter: 'FY2025 Q4', evidenceType: 'actual' },
            { date: '2025-06-30', value: 32.183, company: 'Amazon', quarter: '2025 Q2', evidenceType: 'actual' },
            { date: '2025-06-30', value: 22.446, company: 'Alphabet', quarter: '2025 Q2', evidenceType: 'actual' },
            { date: '2025-06-30', value: 16.538, company: 'Meta', quarter: '2025 Q2', evidenceType: 'actual' },
            { date: '2025-08-31', value: 8.502, company: 'Oracle', quarter: 'FY2026 Q1', evidenceType: 'actual' },
            { date: '2025-09-30', value: 19.394, company: 'Microsoft', quarter: 'FY2026 Q1', evidenceType: 'actual' },
            { date: '2025-09-30', value: 35.095, company: 'Amazon', quarter: '2025 Q3', evidenceType: 'actual' },
            { date: '2025-09-30', value: 23.953, company: 'Alphabet', quarter: '2025 Q3', evidenceType: 'actual' },
            { date: '2025-09-30', value: 18.829, company: 'Meta', quarter: '2025 Q3', evidenceType: 'actual' },
            { date: '2025-11-30', value: 12.033, company: 'Oracle', quarter: 'FY2026 Q2', evidenceType: 'actual' },
            { date: '2025-12-31', value: 29.876, company: 'Microsoft', quarter: 'FY2026 Q2', evidenceType: 'actual' },
            { date: '2025-12-31', value: 39.522, company: 'Amazon', quarter: '2025 Q4', evidenceType: 'actual' },
            { date: '2025-12-31', value: 27.851, company: 'Alphabet', quarter: '2025 Q4', evidenceType: 'actual' },
            { date: '2025-12-31', value: 21.383, company: 'Meta', quarter: '2025 Q4', evidenceType: 'actual' },
            { date: '2026-02-28', value: 18.635, company: 'Oracle', quarter: 'FY2026 Q3', evidenceType: 'actual' },
            { date: '2026-03-31', value: 30.876, company: 'Microsoft', quarter: 'FY2026 Q3', evidenceType: 'actual' },
            { date: '2026-03-31', value: 44.203, company: 'Amazon', quarter: '2026 Q1', evidenceType: 'actual' },
            { date: '2026-03-31', value: 35.674, company: 'Alphabet', quarter: '2026 Q1', evidenceType: 'actual' },
            { date: '2026-03-31', value: 18.997, company: 'Meta', quarter: '2026 Q1', evidenceType: 'actual' },
            { date: '2026-05-31', value: 16.493, company: 'Oracle', quarter: 'FY2026 Q4', evidenceType: 'actual' },
            { date: '2026-06-30', value: 35.802, company: 'Microsoft', quarter: 'FY2026 Q4', evidenceType: 'actual' },
            { date: '2026-06-30', value: 54.208, company: 'Amazon', quarter: '2026 Q2', evidenceType: 'actual' },
            { date: '2026-06-30', value: 44.924, company: 'Alphabet', quarter: '2026 Q2', evidenceType: 'actual' },
            { date: '2026-06-30', value: 30.000, company: 'Meta', quarter: '2026 Q2E', evidenceType: 'forecast' },
            { date: '2026-08-31', value: 18.000, company: 'Oracle', quarter: 'FY2027 Q1E', evidenceType: 'forecast' },
            { date: '2026-09-30', value: 45.000, company: 'Microsoft', quarter: 'FY2027 Q1E', evidenceType: 'forecast' },
            { date: '2026-09-30', value: 48.000, company: 'Amazon', quarter: '2026 Q3E', evidenceType: 'forecast' },
            { date: '2026-09-30', value: 47.000, company: 'Alphabet', quarter: '2026 Q3E', evidenceType: 'forecast' },
            { date: '2026-09-30', value: 39.000, company: 'Meta', quarter: '2026 Q3E', evidenceType: 'forecast' },
            { date: '2026-11-30', value: 20.000, company: 'Oracle', quarter: 'FY2027 Q2E', evidenceType: 'forecast' },
            { date: '2026-12-31', value: 49.000, company: 'Microsoft', quarter: 'FY2027 Q2E', evidenceType: 'forecast' },
            { date: '2026-12-31', value: 53.600, company: 'Amazon', quarter: '2026 Q4E', evidenceType: 'forecast' },
            { date: '2026-12-31', value: 52.400, company: 'Alphabet', quarter: '2026 Q4E', evidenceType: 'forecast' },
            { date: '2026-12-31', value: 47.000, company: 'Meta', quarter: '2026 Q4E', evidenceType: 'forecast' },
            { date: '2027-02-28', value: 22.000, company: 'Oracle', quarter: 'FY2027 Q3E', evidenceType: 'forecast' },
            { date: '2027-03-31', value: 52.000, company: 'Microsoft', quarter: 'FY2027 Q3E', evidenceType: 'forecast' },
            { date: '2027-03-31', value: 57.000, company: 'Amazon', quarter: '2027 Q1E', evidenceType: 'forecast' },
            { date: '2027-03-31', value: 55.000, company: 'Alphabet', quarter: '2027 Q1E', evidenceType: 'forecast' },
            { date: '2027-03-31', value: 42.000, company: 'Meta', quarter: '2027 Q1E', evidenceType: 'forecast' },
            { date: '2027-05-31', value: 24.000, company: 'Oracle', quarter: 'FY2027 Q4E', evidenceType: 'forecast' },
            { date: '2027-06-30', value: 55.000, company: 'Microsoft', quarter: 'FY2027 Q4E', evidenceType: 'forecast' },
            { date: '2027-06-30', value: 61.000, company: 'Amazon', quarter: '2027 Q2E', evidenceType: 'forecast' },
            { date: '2027-06-30', value: 58.000, company: 'Alphabet', quarter: '2027 Q2E', evidenceType: 'forecast' },
        ],
    }),
];
